/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer4_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_viewer" | "ReplyListContainer5_viewer">;
    readonly " $refType": "ReplyListContainer4_viewer";
};
export type ReplyListContainer4_viewer$data = ReplyListContainer4_viewer;
export type ReplyListContainer4_viewer$key = {
    readonly " $data"?: ReplyListContainer4_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer4_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer4_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer5_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'a135a6b77fdb7d6ae6ddf1d5e69c2582';
export default node;
